import { PAYMENT_METHODS } from "../constants";

export function getPaymentMethodConfig(val) {
  return val && PAYMENT_METHODS[val.toLowerCase()];
}
